import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const POSITIVE = [
  'Una capa de dirección para negocios que quieren menos fricción y más control.',
  'Una forma de coordinar ventas, contratos, pagos, ejecución y seguimiento desde un mismo hilo.',
  'Una plataforma pensada para combinar automatización con criterio humano, no para sustituirlo todo a ciegas.',
];

const NEGATIVE = [
  'No es una colección de promesas vagas de IA sin aterrizaje operativo.',
  'No es un escaparate de herramientas sueltas que obligan al equipo a improvisar.',
  'No es una estrategia pública para revelar tu operativa interna, márgenes o estructura sensible.',
];

export default function WhatIsPage() {
  return (
    <>
      <SEO title="Qué es Neuralia369 | Filosofía" description="Qué es y qué no es Neuralia369: filosofía clara, dirección práctica y enfoque a negocio real." path="/que-es" />
      <main className="min-h-screen bg-background px-4 py-16 sm:px-6 lg:px-8" data-testid="what-is-page">
        <div className="mx-auto max-w-7xl grid gap-6 xl:grid-cols-2">
          <motion.section initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="glass-card tracing-panel p-8" data-testid="what-is-positive-card">
            <p className="editorial-kicker mb-4">Qué es Neuralia369</p>
            <h1 className="text-4xl sm:text-5xl text-text-heading">Un sistema operativo con IA para el negocio real.</h1>
            <div className="mt-6 space-y-3">
              {POSITIVE.map((item, index) => <div key={item} className="rounded-[22px] border border-primary/15 bg-primary/5 p-4 text-sm text-text-body" data-testid={`what-is-positive-item-${index}`}>{item}</div>)}
            </div>
          </motion.section>

          <motion.section initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 }} className="glass-card tracing-panel p-8" data-testid="what-is-negative-card">
            <p className="editorial-kicker mb-4">Qué NO es</p>
            <h2 className="text-4xl sm:text-5xl text-text-heading">No más dispersión disfrazada de innovación.</h2>
            <div className="mt-6 space-y-3">
              {NEGATIVE.map((item, index) => <div key={item} className="rounded-[22px] border border-border-subtle bg-background/55 p-4 text-sm text-text-body" data-testid={`what-is-negative-item-${index}`}>{item}</div>)}
            </div>
          </motion.section>
        </div>
      </main>
    </>
  );
}